import LandingHeaderV2 from '@/modules/LandingHeaderV2';
import cx from 'classnames';
import dynamic from 'next/dynamic';
import React from 'react';

import Footer from 'modules/Footer';

import styles from './style.module.scss';

const CookieConsentPrompt = dynamic(() => import('@/app/components/CookieConsentPrompt'));
const ProfileBanner = dynamic(
  () => import('@/app/components/ProfileBanner').then(mod => ({ default: mod.ProfileBanner })),
  {
    ssr: false,
  },
);

export const CMSContainer = ({
  children,
  shouldUpdateFooterStyles,
}: {
  children: React.ReactNode;
  shouldUpdateFooterStyles?: boolean;
}) => {
  return (
    <div className={styles.outsideContainer}>
      <LandingHeaderV2 />
      {children}
      <Footer className={cx(shouldUpdateFooterStyles && styles.footer)} />
      <CookieConsentPrompt />
      <ProfileBanner />
    </div>
  );
};

export default CMSContainer;
